import { Component, Input, OnInit, Optional } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ArcAngelService } from '../../../core/services/arc-angel.service';
import { IllumPolygonCreatorService } from '../../../core/services/Illum-polygon-creator.service';
import { catchError, of } from 'rxjs';


@Component({
  selector: 'app-incident-edit-dialog',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './incident-edit-dialog.component.html',
  styleUrls: ['./incident-edit-dialog.component.css']
})
export class IncidentEditDialogComponent implements OnInit {
  @Input() mapEntity: any;

  name: string = '';
  description: string = '';

  hasMedGeo = false;
  hasLowGeo = false;
  isGeofenceIncident = false;

  medGeoCoords: any;
  lowGeoCoords: any;

  constructor(
    public activeModal: NgbActiveModal,
    @Optional() private arcAngelService?: ArcAngelService,
    @Optional() private arcAngelPolygonCreator?: IllumPolygonCreatorService
  ) {}

  ngOnInit(): void {
    if (!this.mapEntity) {
      return;
    }

    this.name = this.mapEntity.name ?? '';
    this.description = this.mapEntity.description ?? '';

    try {
      this.isGeofenceIncident = (this.mapEntity.obj?.type === 'GEOFENCE');
    } catch (e) {
      this.isGeofenceIncident = false;
    }

    this.hasMedGeo = !!(this.mapEntity.hasMedGeometry?.() || this.mapEntity.medGeometry || this.mapEntity.lowGeometryMapEntity?.medGeometry);
    this.hasLowGeo = !!(this.mapEntity.hasLowGeometry?.() || this.mapEntity.lowGeometry || this.mapEntity.lowGeometryMapEntity);
  }

  ok(): void {
    this.mapEntity.name = this.name;
    this.mapEntity.description = this.description;

    try {
      if (this.mapEntity.getObj && this.arcAngelService?.updateEventDetails) {
        this.arcAngelService.updateEventDetails(
          this.mapEntity.getObj(),
          this.name,
          this.description,
          this.mapEntity.status,
          this.medGeoCoords,
          this.lowGeoCoords
        ).pipe(
          catchError(err => {
            console.error('updateEventDetails failed', err);
            return of(null);
          })
        ).subscribe((result) => {
          this.activeModal.close({ action: 'updated', entity: this.mapEntity, result });
        });
        return;
      } else if (this.mapEntity.getEventId && this.arcAngelService?.updateSafeZone) {
        const eventId = this.mapEntity.getEventId();
        const arcId = this.mapEntity.getArcAngelId?.() ?? this.mapEntity.arcAngelId ?? this.mapEntity.id;
        const lat = this.mapEntity.getLatitude?.() ?? this.mapEntity.lat ?? this.mapEntity.latitude;
        const lon = this.mapEntity.getLongitude?.() ?? this.mapEntity.lon ?? this.mapEntity.longitude;
        this.arcAngelService.updateSafeZone(
          eventId,
          arcId,
          this.name,
          this.description,
          this.mapEntity.getIsActive?.() ?? true,
          lat,
          lon
        );
      } else {
      }
    } catch (err) {
      console.error('IncidentEditDialogComponent: error calling ArcAngelService', err);
    }

    this.activeModal.close({ action: 'updated', entity: this.mapEntity });
  }

  cancel(): void {
    this.activeModal.dismiss('cancel');
  }

  private createShape(type: 'med' | 'low'): void {
    if (this.arcAngelPolygonCreator?.startDrawing) {
      const eventId = this.mapEntity.getEventId?.() ?? this.mapEntity.eventId ?? undefined;
      try {
      //   this.arcAngelPolygonCreator.startDrawing(type, eventId, (coords: any) => {
      //     if (type === 'med') {
      //       this.setMedGeometry(coords);
      //     } else {
      //       this.setLowGeometry(coords);
      //     }
      //   }
      // );
        return;
      } catch (err) {
      }
    }

  }

  editMediumGeometry(): void {
    this.createShape('med');
  }
  addMediumGeometry(): void {
    this.createShape('med');
  }
  editLowGeometry(): void {
    this.createShape('low');
  }
  addLowGeometry(): void {
    this.createShape('low');
  }

  // Called by polygon tool callback
  setMedGeometry(coords: any): void {
    this.medGeoCoords = coords;
    this.hasMedGeo = true;
  }
  setLowGeometry(coords: any): void {
    this.lowGeoCoords = coords;
    this.hasLowGeo = true;
  }
}